import { Fragment, useEffect, useRef, useState } from 'react';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import SimpleLoading from '../../Loading/SimpleLoading';
import { areObjectsDifferent, formatJson, getOnlyChangedValuesForApiPayload, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import Collapse from '../../inc/Collapse';
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import Helper from '../../../inc/Helper';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import { connect } from 'react-redux';

let defaultApiManagerObject = null;
const ApiManagerDetailView = () => {
    const [apiManagerObj, setApiManagerObj] = useState({});

    const { id } = useParams();

    const [loading, setLoading] = useState(true);

    const appDataRef = useRef([]);

    let getByIdApiCall = false; 
  
    useEffect(() => { 
        getApiManagerDetails();
    }, [])

    let validator; 

    const validationConfigure = () => {
        let fieldConfig = [
            { name: "api_url", displayName: "Api url", types: ["Required"] },
            { name: "api_method", displayName: "Api method", types: ["Required"] }, 
            { name: "app", displayName: "App", types: ["Required"] }
        ];

        if(!validator) {
            validator = new FormValidator(fieldConfig)
        }
    };

    validationConfigure();

    const appMapFunction = (item) => {
        return {
            text: `${item.app_name}`,
            id: item.app_id
        };
    };

    const getApiManagerDetails = () => { 
        if(getByIdApiCall) return;

        getByIdApiCall = true;
        setLoading(true);

        let api = Api
        api.setUserToken()
        api.axios().get(Settings.apiAppUrl+`/api-manager/?id=${id}`,{}).then(function(res) { 
            if(res?.status === 200){
                setApiManagerObj({...res?.data?.results[0], sample_payload: res?.data?.results[0]?.sample_payload ? formatJson(res?.data?.results[0]?.sample_payload) : '', body: res?.data?.results[0]?.body ? formatJson(res?.data?.results[0]?.body) : ''});
                defaultApiManagerObject = {...res?.data?.results[0], sample_payload: res?.data?.results[0]?.sample_payload ? formatJson(res?.data?.results[0]?.sample_payload) : '', body: res?.data?.results[0]?.body ? formatJson(res?.data?.results[0]?.body) : ''};
                setLoading(false);
            } else {
                Helper.alert(res?.data?.message, 'error');
            }
        }).catch((res) => { 
            getPopupMessageBasedOnStatus(res) 
            setLoading(false)
        })
    };

    const ApiManagerModule = () => { 
        let textBoxInputSettings = [
            {
                className: "col-lg-4",
                label: "Api url",
                inputType: "text",
                id: "api_url",
                required: true,
                name: "api_url"
            },
            {
                className: "col-lg-4",
                label: "Api method",
                inputType: "dropdown",
                options: Settings.httpMethodOptions,
                id: "api_method",
                name: "api_method",
                required: true
            },
            {
                className: "col-lg-4",
                label: "App",
                inputType: "paginated_dropdown",
                options: [{ value: apiManagerObj?.app, label: apiManagerObj?.app_name }],
                apiUrl: Settings.apiAppUrl+'/details',
                currentSearchTerm: '',
                allDataRef: appDataRef,
                mapFunction: appMapFunction,
                placeHolder: 'Select app',
                id: "app",
                name: "app",
                required: true
            },
            {
                className: "col-lg-4",
                label: "Status",
                inputType: "dropdown",
                options: Settings.enumStatus,
                id: "status",
                placeHolder: 'Select status',
                name: "status"
            },
            {
                className: "col-lg-4",
                label: "Api name",
                inputType: "dropdown",
                options: Settings.apiNamesEnum,
                id: "api_name",
                name: "api_name",
                placeHolder: 'Select api name'
            },
            {
                className: "col-lg-4",
                label: "Timeout",
                inputType: "number",
                id: "timeout",
                name: "timeout"
            },
            {
                className: "col-lg-4",
                label: "Retry count",
                inputType: "number", 
                id: "retry_count",
                name: "retry_count"
            },  
            {
                className: "col-lg-4",
                label: "Body",
                inputType: "textarea",
                id: "body",
                name: "body"
            },
            {
                className: "col-lg-4",
                label: "Sample payload",
                inputType: "textarea",
                id: "sample_payload",
                name: "sample_payload"
            },
            {
                className: "col-lg-4",
                label: "Priority",
                inputType: "number",
                id: "priority", 
                name: "priority"
            },
            {
                className: "col-lg-4",
                label: "is Asynchronous", 
                inputType: "checkbox",
                id: "is_asynchronous",
                name: "is_asynchronous"
            }
        ];

        return (
            <Collapse open={true} title={"General"}>
                <div className='row mb-3'>
                    <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setApiManagerObj} currentState={apiManagerObj} />
                </div>
            </Collapse>
        );
    };

    const SaveHandler = () => {
        if(!areObjectsDifferent(defaultApiManagerObject, apiManagerObj)) return;
        
        let validData = {
            ...apiManagerObj
        };

        if(!validator.isValid(validData)){
            validator.displayMessage();
            validator.reset() 
            return;
        };

        let api = Api;
        api.setUserToken();

        const apiPayload = getOnlyChangedValuesForApiPayload({
            newData: {
                ...apiManagerObj,
                body: apiManagerObj?.body ? formatJson(apiManagerObj?.body) : '',
                sample_payload: apiManagerObj?.sample_payload ? formatJson(apiManagerObj?.sample_payload) : ''
            },
            originalData: {
                ...defaultApiManagerObject,
                body: defaultApiManagerObject?.body ? formatJson(defaultApiManagerObject?.body) : '',
                sample_payload: defaultApiManagerObject?.sample_payload ? formatJson(defaultApiManagerObject?.sample_payload) : ''
            },
            booleanFields: ['is_asynchronous'],
            integerFields: ['retry_count', 'priority', 'timeout']
        });

        api.axios().patch(Settings.apiAppUrl+`/api-manager/update/${id}/`, apiPayload).then(function(res){
            if(res?.status === 200){
                Helper.alert(res?.data?.message || 'Api manager updated successfully', 'success');
                getApiManagerDetails();
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => {  
            getPopupMessageBasedOnStatus(res);
        })  
    };

    return (
        <div className='container-fluid'>
            <NavigationHeder title={ `<span style="color:#000;"> Edit Api Manager #</span> ${apiManagerObj?.api_url?.length > 30 ? apiManagerObj?.api_url?.substring(0, 30) + '...' || '-' : apiManagerObj?.api_url || '-'}` }>
                <LinkBtn to={-1} isActive= {false} title={"Close"} />
                <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
            </NavigationHeder>
        
            {loading ? <SimpleLoading /> : (
                <Fragment> {ApiManagerModule()} </Fragment>
            )} 
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth
    }
}

export default connect(mapStateToProps) (MasterComponentWraper(ApiManagerDetailView));